export default __webpack_public_path__ + "src/images/about/Group-1c4669fa72ac0896a3c5e19d521bf45e.png";